import React from "react";

import { PortfolioAllocationPage } from "@harrow-education/ui-components";

const PortfolioAllocation = (props) => {
  return <PortfolioAllocationPage {...props} />;
};

export default PortfolioAllocation;
